<template>
  <div class="el-tabs-Line">
    <el-tabs v-model="getValue">
      <el-tab-pane
        v-for="item in props.tabListData"
        :key="item.name"
        :label="item.label as string"
        :name="item.name"
      />
    </el-tabs>
    <div class="el-tabs-Line-pane">
      <slot />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { definePropType, mutable } from '@pit-element-plus/utils'
import type { TabListDatas } from './tabs'

defineOptions({
  name: 'TabsLine',
})

const props = defineProps({
  modelValue: {
    type: [String, Number],
  },
  tabListData: {
    type: definePropType<TabListDatas>(Array),
    default: () => mutable([]),
  },
  noCard: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits({
  change: (val: string | number) => val,
})

const getValue = computed({
  get() {
    return props.modelValue as string | number
  },
  set(val: string | number) {
    emit('change', val)
  },
})
</script>
